// This file is AUTOGENERATED, do not edit it manually!!!

export const inlineEdit = {
    ActivityChildrenActualHours_Text: 'Tijdsregistraties voor alle subactiviteiten:',
    ActivityChildrenEstimatedHours_Text: 'Geschatte uren voor alle subactiviteiten:',
    ActivityOwnBudget_Text: 'Budget voor de activiteit:',
    ActivityOwnEstimatedHours_Text: 'Geschatte uren voor de activiteit:',
    ActivitySubactivitiesBudget_Text: 'Budget voor alle subactiviteiten:',
    ActualCompletion_Text: 'Werkelijke voltooiing',
    ActualHours_Total_Text: 'Werkelijke bestede uren, totaal:',
    AddTimeEntry_Text: 'Tijdregistratie toevoegen',
    AddUser_Text: 'Gebruiker uitnodigen',
    AddWeeklyTime_Text: 'Wekelijkse tijd toevoegen',
    Apply: 'Toepassen',
    Assignees_Text: 'Toegewezen personen',
    BudgetedCost_Text: 'Totaal projectbudget:',
    BudgetPadding_Text: 'Contingentie:',
    BudgetTotal_Text: 'Budget, totaal:',
    Cancel: 'Annuleren',
    Close: 'Sluiten',
    Combobox_Add: 'Toevoegen ',
    Combobox_KeepTyping: 'Blijf typen...',
    Combobox_MultipleSelectDefault: 'Selecteer enkele opties',
    Combobox_NoResults: 'Geen resultaten',
    Combobox_NoResultsMatch: 'Geen resultaten gevonden voor ',
    Cost_Text: 'Facturatie:',
    CreateAndSelect: 'Maken en selecteren',
    CustomerLabel: 'Klant',
    day_template: '1#{0} dag#{0} dagen',
    Duration_Text: 'Duur',
    EditProjectMembers_Title: 'Projectleden',
    EditTaskAssignees_Title: 'Toegewezen personen',
    End_Text: 'Einde',
    EndDate_Text: 'Einddatum',
    EstimatedHours_Text: 'Geschatte uren:',
    EstimatedHours_Total_Text: 'Geschatte uren, totaal:',
    field_for_all_activities: 'Dit veld is alleen voor activiteiten <b style=\"white-space: nowrap;\">({0} taken, {1} problemen, {2} verzoeken)</b>',
    field_for_issues: 'Dit veld is alleen voor <b style=\"white-space: nowrap;\">{0} problemen</b>',
    field_for_projects: 'Dit veld is alleen voor <b style=\"white-space: nowrap;\">{0} projecten</b>',
    field_for_requests: 'Dit veld is alleen voor <b style=\"white-space: nowrap;\">{0} verzoeken</b>',
    field_for_tasks: 'Dit veld is alleen voor <b style=\"white-space: nowrap;\">{0} taken</b>',
    Hours_Short_Text: 'u',
    HoursLeftLabel: 'Uren over:',
    InternalCost_Text: 'Werkelijke kosten:',
    NonProjectMembers_Text: 'Niet-projectleden',
    Not_Space_Members: 'Geen leden van de ruimte',
    Overloaded_Text: 'Overbelast',
    OwnActualHours_Text: 'Tijdsregistraties voor de activiteit:',
    PlannedExpenses_Text: 'Geplande uitgaven:',
    PortfolioLabel: 'Portefeuille',
    Progress: 'Voortgang',
    ProgressCalculatedBySubActivities: 'Gebaseerd op de voortgang van subactiviteiten',
    ProjectChildrenActualHours_Text: 'Tijdsregistraties voor activiteiten:',
    ProjectChildrenEstimatedHours_Text: 'Geschatte uren voor alle activiteiten:',
    ProjectMembers_Text: 'Projectleden',
    ProjectOwnBudget_Text: 'Arbeidsbudget voor het project:',
    ProjectOwnEstimatedHours_Text: 'Geschatte uren voor het project:',
    ProjectSubactivitiesBudget_Text: 'Budget voor alle activiteiten:',
    Space_Members: 'Leden van de ruimte',
    Start_Text: 'Start',
    StartDate_Text: 'Startdatum',
    Teams_Text: 'Teams',
    Timelogs_In_Past: 'Het bewerken van de tijdregistratie voor een activiteit die meer dan {0} geleden heeft plaatsgevonden, wordt niet aanbevolen. Weet u zeker dat u wilt doorgaan?',
    Timelogs_In_Past_Short: 'Het bewerken van de tijdregistratie voor een activiteit die meer dan {0} geleden heeft plaatsgevonden, wordt niet aanbevolen.',
    TimeLogs_Warning_Project_Closed: 'Het toevoegen van tijd aan een gesloten project wordt niet aanbevolen. Weet u zeker dat u tijd wilt toevoegen aan het gesloten project?',
    TimeLogs_Warning_Project_Closed_Short: 'Het toevoegen van tijd aan een gesloten project wordt niet aanbevolen.',
    TimeLogs_Warning_Task_Closed: 'Het toevoegen van tijd aan een gesloten activiteit wordt niet aanbevolen. Weet u zeker dat u tijd wilt toevoegen aan deze gesloten activiteit?',
    TimeLogs_Warning_Task_Closed_Short: 'Het toevoegen van tijd aan een gesloten activiteit wordt niet aanbevolen.',
    Tooltip_Dependent_Template: '{0} is gekoppeld aan een afhankelijke activiteit en kan niet worden gewijzigd.',
    Tooltip_HasChildren_Template: '{0} is berekend op basis van subactiviteiten en kan niet worden gewijzigd.',
    Tooltip_ItemCompleted: 'Kan niet worden bewerkt omdat het is gekoppeld aan een gesloten activiteit/project.',
    Tooltip_NoRightForUserRole_Template: '{0} kan niet worden gewijzigd. U hebt geen toestemming om dit veld te bewerken.',
    Tooltip_Open_Details: 'Open de details om dit veld te bewerken.',
    Untitled: 'Zonder titel',
    Validation_ActComplDateRange: 'De werkelijke voltooiingsdatum valt niet binnen het verwachte bereik.',
    Validation_DateMandatory: 'Datum is een verplicht veld.',
    Validation_DurationMandatory: 'Duur is een verplicht veld.',
    Validation_EndDateRange: 'De einddatum valt niet binnen het verwachte bereik.',
    Validation_FieldMandatory: 'Dit is een verplicht veld.',
    Validation_FromDateRange: 'De startdatum valt niet binnen het verwachte bereik.',
    Validation_Interger: 'De waarde moet een geheel getal zijn.',
    Validation_InvalidDate: 'Datum moet in \'{0}\' formaat zijn.',
    Validation_NumberRange: 'De waarde moet tussen {0} en {1} liggen.',
    Validation_Range: 'De waarde valt niet binnen het verwachte bereik.',
    Validation_StartDateRange: 'De startdatum valt niet binnen het verwachte bereik.',
    Validation_ToDateRange: 'De einddatum valt niet binnen het verwachte bereik.',
    Validation_WeekendOrVacation: 'De waarde mag niet op een weekend of vakantie vallen.',
    Warning_UnassigneFromAllTasksInProject: 'Verwijderde leden worden ontkoppeld van alle activiteiten in dit project.',
    Warning_UnassignFromAllTasksInProject_Single: 'Verwijderde gebruiker zal worden ontkoppeld van alle activiteiten in dit project.',
};
